import { HeaderRoot } from '@common/components';
import { EntityIcon } from '@common/Entity/EntityIcons';
import { ProjectBrowserToggleButton } from '@common/ProjectBrowser/ProjectBrowserToggleButton';
import { ProjectDetail } from '@common/queries/project';
import { Entity } from '@common/types/Entity';
import { Private_Routes } from '@common/url';
import { theme } from '@prophecy/theme';
import { Text, Ellipsis, Stack, ButtonGroup } from '@prophecy/ui-v3';
import DocumentTitle from '@prophecy/utils/react/DocumentTitle';
import { noop } from 'lodash-es';
import styled from 'styled-components';

import { AttachClusterWithFabric } from '../Workflow/AttachFabric/AttachClusterWithFabric';
import { ProjectOptions } from './ProjectOptions';

const StyledStack = styled(Stack)`
  min-width: 0;
`;

const StyledHeaderRoot = styled(HeaderRoot)`
  justify-content: space-between;
  width: 100%;
  flex-direction: row;
  display: flex;
`;

const StyledButtonGroup = styled(ButtonGroup)`
  align-items: center;
`;

export function Header({ project }: { project: ProjectDetail }) {
  const { name, _id: projectId } = project;
  return (
    <>
      <DocumentTitle title={`Project Lineage`} />
      <StyledHeaderRoot>
        <Stack direction='horizontal' gap={theme.spaces.x16} alignY='center' align='center'>
          <ProjectBrowserToggleButton />
          <StyledStack direction='horizontal' gap={theme.spaces.x8} alignY='center'>
            <EntityIcon size='s' entity={Entity.Project} />
            <Ellipsis tooltip={true} tooltipProps={{ placement: 'bottom', align: 'end' }}>
              <Text level='sm'>{name}</Text>
            </Ellipsis>
          </StyledStack>
          <StyledButtonGroup size='xs'>
            <ButtonGroup.Item
              variant='primary'
              alternate
              elementType='link'
              to={Private_Routes.Project.home.getUrl({ uid: projectId })}
              data-test-id='project-lineage-header-metadata-button'>
              Metadata
            </ButtonGroup.Item>
            <ProjectOptions project={project} />
          </StyledButtonGroup>
        </Stack>
        <span></span>
        <Stack direction='horizontal' gap={theme.spaces.x8} alignY='center'>
          <AttachClusterWithFabric
            projectId={projectId}
            hide={false}
            disabledMessage={'Open a pipeline to attach cluster.'}
            disabled={true}
            setSessionUsed={noop}
          />
        </Stack>
      </StyledHeaderRoot>
    </>
  );
}
